import { Checkbox, MultiSelect, NumberInput, Select, SimpleGrid, TextInput, Textarea } from "@mantine/core";

import { useT } from "../i18n/script";

/** Definicija polja (isti format kao app/core/fields.py na backendu). */
export interface FieldDef {
  key: string;
  label: string;
  type: "text" | "number" | "integer" | "date" | "bool" | "select" | "multiselect" | "textarea";
  required?: boolean;
  options?: string[];
  min?: number;
  max?: number;
  unit?: string;
  help?: string;
}

/** Forma generisana iz definicija polja (fenološke faze, proširenja voćnjaka, šifarnici). */
export function DynamicFields({ defs, values, onChange, cols = 2, disabled }: {
  defs: FieldDef[]; values: Record<string, unknown>; onChange: (v: Record<string, unknown>) => void; cols?: number; disabled?: boolean;
}) {
  const { t } = useT();
  const set = (k: string, v: unknown) => onChange({ ...values, [k]: v });
  return (
    <SimpleGrid cols={{ base: 1, sm: cols }} spacing="sm">
      {defs.map((f) => {
        const label = t(f.label) + (f.unit ? ` (${f.unit})` : "");
        const common = { label, required: f.required, description: f.help ? t(f.help) : undefined, disabled };
        const v = values[f.key];
        switch (f.type) {
          case "number":
          case "integer":
            return <NumberInput key={f.key} {...common} value={(v as number) ?? ""} min={f.min} max={f.max}
              decimalScale={f.type === "integer" ? 0 : 3} decimalSeparator="," onChange={(x) => set(f.key, x === "" ? null : Number(x))} />;
          case "date":
            return <TextInput key={f.key} {...common} type="date" value={(v as string) ?? ""} onChange={(e) => set(f.key, e.currentTarget.value || null)} />;
          case "bool":
            return <Checkbox key={f.key} mt="lg" label={label} checked={!!v} disabled={disabled} onChange={(e) => set(f.key, e.currentTarget.checked)} />;
          case "select":
            return <Select key={f.key} {...common} data={f.options ?? []} value={(v as string) ?? null} clearable onChange={(x) => set(f.key, x)} />;
          case "multiselect":
            return <MultiSelect key={f.key} {...common} data={f.options ?? []} value={(v as string[]) ?? []} onChange={(x) => set(f.key, x)} />;
          case "textarea":
            return <Textarea key={f.key} {...common} autosize minRows={2} value={(v as string) ?? ""} onChange={(e) => set(f.key, e.currentTarget.value)} />;
          default:
            return <TextInput key={f.key} {...common} value={(v as string) ?? ""} onChange={(e) => set(f.key, e.currentTarget.value)} />;
        }
      })}
    </SimpleGrid>
  );
}

export const FIELD_TYPES = [
  { value: "text", label: "Tekst" }, { value: "number", label: "Broj" }, { value: "integer", label: "Cijeli broj" },
  { value: "date", label: "Datum" }, { value: "bool", label: "Da/Ne" }, { value: "select", label: "Izbor" },
  { value: "multiselect", label: "Višestruki izbor" },
];
